import React, {useState, useEffect} from "react"
import PropTypes from "prop-types"

// styling and images
import "./Checkbox.scss"
import {Check as CheckIcon} from "../../images/js"

function Checkbox({onChange, checked, children, field, id, required}) {
  const [_checked, _setChecked] = useState(checked)

  useEffect(() => {
    _setChecked(checked)
  }, [checked])

  const _onChange = (e) => {
    _setChecked(e.target.checked)
    if(onChange) {
      onChange({checked:e.target.checked, field})
    }
  }

  let svg = _checked ? <CheckIcon /> : null

  return (
    <div className={`c-checkbox ${required && !_checked ? 'invalid':''}`}>
      <label>
        <input type="checkbox" checked={_checked} onChange={_onChange} id={id} />
        <div className={`checkmark ${_checked ? "active" : "passive"}`}>
          {svg}
        </div>
        <div className="text">
          {children}
        </div>
      </label>
    </div>
  )
}

Checkbox.propTypes = {
  required:PropTypes.bool.isRequired
}

Checkbox.defaultProps = {
  required:false
}

export default Checkbox